import { render, staticRenderFns } from "./BCXUserListItem.vue?vue&type=template&id=2ad14e6c&scoped=true"
import script from "./BCXUserListItem.vue?vue&type=script&lang=ts"
export * from "./BCXUserListItem.vue?vue&type=script&lang=ts"
import style0 from "./BCXUserListItem.vue?vue&type=style&index=0&id=2ad14e6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad14e6c",
  null
  
)

export default component.exports